import React from 'react'

import { getBrandConfig } from '../../../config/brands'
import { AdvertiserLogo } from '../../../shared/assets'

const { brandConfig } = getBrandConfig()

export const Logo = () => <AdvertiserLogo size="m" iconName={brandConfig.logo} w="196px" h="30px" />
